import { Flex } from 'reflexbox';

import * as graphql from '@treams/treams-network';
import { Button, Paragraph, UnorderedList } from '@treams/treams-ui';

import { SharedFields } from '../ProductConfiguration';
import ProductLayout from '../ProductLayout';
import ProductTile from '../ProductTile';

function translate(key: string): { title: string; description: string } | undefined {
	if (key === 'auth') {
		return {
			title: 'Koppelen met HoorayHR',
			description:
				'Om te verbinden met HoorayHR, moet je inloggen via de onderstaande button. Je wordt doorverwezen naar de site van HoorayHR en krijgt daarna een scherm te zien met een overzicht van de gegevens die je gaat delen. Vervolgens kun je hier akkoord op geven.',
		};
	}

	if (key in SharedFields) {
		return SharedFields[key];
	}

	return {
		title: key,
		description: 'Nog niet geconfigureerd',
	};
}

function Description() {
	return (
		<>
			<Paragraph mb={2}>
				HoorayHR is de HR tool waarmee je eenvoudig al je HR zaken stroomlijnt. Met HoorayHR beheer
				je al je HR zaken op één plek. Ga van losse documenten en Excel spreadsheets, naar één
				slimme tool voor jouw HR administratie. Zo hou jij meer tijd over voor hetgeen er echt toe
				doet: jouw mensen.
			</Paragraph>
			<Paragraph>Bespaar direct tijd met onze slimme features:</Paragraph>
			<Paragraph mb={2}>
				<UnorderedList>
					<li>Onboarden met handige workflows</li>
					<li>Managen van al je HR taken</li>
					<li>Groeien van je team met HR</li>
					<li>
						En koppelbaar met bijvoorbeeld je loonadministratie, boekhouding en je eigen workspace
					</li>
				</UnorderedList>
			</Paragraph>
			<Paragraph mb={2}>
				<Flex>
					<a href="https://www.hoorayhr.io" target="_blank" rel="noreferrer">
						<Button type="secondary" title="Naar de site van HoorayHR" />
					</a>
				</Flex>
			</Paragraph>
		</>
	);
}

export default function Hooray() {
	return (
		<ProductLayout
			id="hooray"
			type={graphql.ConnectorType.Hooray}
			description={<Description />}
			headerImageURL="https://assets.ontreams.com/marketplace/hooray-wide.png"
			translate={translate}
			pricingLink="https://www.hoorayhr.io/prijzen/"
			documentationLink="https://treams.notion.site/Uitleg-HoorayHR-integreren-met-Treams-7337aec5374c4c82942de20fc444d69f"
		/>
	);
}

export function HoorayTile(props: { selected: boolean }) {
	return (
		<ProductTile
			id="hooray"
			title="HoorayHR"
			description="Helpt het HR-proces te stroomlijnen."
			logoImageURL="https://assets.ontreams.com/marketplace/hooray.svg"
			selected={props.selected}
		/>
	);
}
